import React from "react";
import "./loading.css";

const Loading = () => {
  return <div className="loading">Loading...</div>;
};

export default Loading;
